import { render, staticRenderFns } from "./service_alert_banner.vue?vue&type=template&id=1dbf447a&scoped=true&"
import script from "./service_alert_banner.vue?vue&type=script&lang=js&"
export * from "./service_alert_banner.vue?vue&type=script&lang=js&"
import style0 from "./service_alert_banner.vue?vue&type=style&index=0&id=1dbf447a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbf447a",
  null
  
)

export default component.exports